import { cardAssetKey, pokerCardLabel, type DisplayPokerCard } from './pokerCards';

export { pokerCardLabel };
export type { DisplayPokerCard };

export default function PokerCardFace({ card, className = '', faceDown = false }: {
  card: DisplayPokerCard;
  className?: string;
  faceDown?: boolean;
}) {
  const label = pokerCardLabel(card);
  const key = cardAssetKey(card);
  if (faceDown) {
    return <span aria-label="Face-down playing card" className={`poker-card-face face-down ${className}`.trim()}><i /></span>;
  }
  if (!key) {
    return <span className={`poker-card-face fallback ${className}`.trim()}>{label}</span>;
  }
  return (
    <span className={`poker-card-face ${className}`.trim()}>
      <img alt={label} draggable={false} src={`/cards/${key}.svg`} />
    </span>
  );
}
